{
  "add": "إضافة",
  "age": {
    "range": {
      "ADULT": "بالغ",
      "BABY": "رضيع",
      "CHILD": "طفل",
      "SENIOR": "مسن",
      "TURNING_SENIOR": "مقبل على الشيخوخة",
      "YOUNG_ADULT": "شاب بالغ",
      "YOUTH": "يافع"
    },
    "unknown": "العمر غير معروف",
    "years": "العمر {{ years }}"
  },
  "ages": {
    "ADULT": "(21-63) بالغ",
    "BABY": "(0-1) رضيع",
    "CHILD": "(1-5) طفل",
    "SENIOR": "(+65) مسن",
    "TURNING_SENIOR": "(64) مقبل على الشيخوخة",
    "YOUNG_ADULT": "(19-20) شاب بالغ",
    "YOUTH": "(6-18) يافع"
  },
  "back": "رجوع",
  "cancel": "إلغاء",
  "childCaregiverStatus": {
    "CAREGIVER": "نعم",
    "NOT_CAREGIVER": "لا"
  },
  "citizenshipStatus": {
    "IMMIGRANT": "وضع هجرة مقبول (بطاقة خضراء، إلخ.)",
    "NOT_ANSWERED": "أفضل عدم الإجابة",
    "US_CITIZEN": "مواطن أمريكي",
    "US_NATIONAL": "مواطن أمريكي (U.S. National)"
  },
  "clear": "مسح",
  "clearAddress": "مسح العنوان",
  "clearFilters": "مسح الفلاتر",
  "clinic": "عيادة",
  "close": "إغلاق",
  "continue": "متابعة",
  "dateOfBirth": "تاريخ الميلاد",
  "datePicker": {
    "placeholder": "اختر تاريخاً",
    "required": "يرجى اختيار تاريخ."
  },
  "datetime": {
    "daysWithCount_one": "يوم واحد",
    "daysWithCount_other": "{{count}} يوم",
    "monthsWithCount_one": "شهر واحد",
    "monthsWithCount_other": "{{count}} شهر",
    "yearsWithCount_one": "سنة واحدة",
    "yearsWithCount_other": "{{count}} سنة"
  },
  "day": "يوم",
  "delete": "حذف",
  "discardFormChangesDialog": {
    "cancelButton": "العودة للتعديل",
    "confirmButton": "المغادرة على أي حال",
    "creating": "إنشاء",
    "description": "هناك تغييرات غير محفوظة في {{entity}} التي تقوم بـ {{action}}. إذا غادرت هذه الصفحة، ستفقد ما أحرزته.",
    "entity": "العنصر",
    "title": "هل أنت متأكد أنك تريد المغادرة؟",
    "updating": "تعديل"
  },
  "documentGroups": {
    "PROOF_OF_CITIZENSHIP": "إثبات الهجرة",
    "PROOF_OF_EXEMPTION": "إثبات الإعفاء",
    "PROOF_OF_EXPENSE": "إثبات المصاريف",
    "PROOF_OF_IDENTITY": "إثبات الهوية",
    "PROOF_OF_INCOME_AND_EMPLOYMENT": "إثبات الدخل والتوظيف",
    "PROOF_OF_INSURANCE": "إثبات التأمين المقدم من صاحب العمل أو تأمين آخر",
    "PROOF_OF_RESIDENCE": "إثبات الإقامة",
    "PROOF_OF_WORK": "إثبات العمل",
    "SOCIAL_SECURITY_NUMBER": "رقم الضمان الاجتماعي"
  },
  "documentTypes": {
    "ALIMONY_PAID": "النفقة المدفوعة",
    "AUTHORIZED_EMPLOYMENT_ID": "هوية عمل معتمدة",
    "BANK_STATEMENTS": "كشوف حساب بنكية",
    "BIRTH_CERTIFICATE": "شهادة ميلاد",
    "CHILDCARE": "رعاية الأطفال",
    "CHILDS_BIRTH_CERTIFICATE": "شهادة ميلاد الطفل",
    "CHILDS_PASSPORT": "جواز سفر الطفل",
    "COURT_ORDERED_STATEMENTS": "بيانات صادرة عن المحكمة",
    "DOCTORS_NOTE": "مذكرة من الطبيب",
    "DRIVERS_LICENSE": "رخصة قيادة",
    "EXPENSE_OTHER": "أخرى",
    "FOSTER_CARE_VERIFICATION_LETTER": "خطاب تحقق من الرعاية البديلة",
    "GUARDIANSHIP_OR_CUSTODY_PAPERS": "أوراق الوصاية أو الحضانة",
    "IMIGRATION_DOCUMENTS_AND_APPROVALS": "مستندات وموافقات الهجرة",
    "INSURANCE_CARD": "بطاقة التأمين",
    "INSURANCE_CARRIER_INFO": "شركة التأمين - الاسم والعنوان",
    "INSURANCE_POLICY_NUMBER": "رقم وثيقة التأمين",
    "IRA_CONTRIBUTIONS": "مساهمات IRA",
    "I_20": "I-20",
    "LETTER_OF_STATEMENT_FROM_EMPLOYER": "خطاب من صاحب العمل",
    "MEDICAL_EXPENSE": "مصروف طبي",
    "MEDICARE_CARD": "بطاقة Medicare",
    "MORTGAGE_STATEMENT": "كشف حساب الرهن العقاري",
    "MOVING_EXPENSES": "تكاليف الانتقال",
    "PASSPORT": "جواز سفر",
    "PAY_STUBS": "قسائم الراتب (آخر 30 يوماً)",
    "PENSION_STATEMENTS": "كشوف المعاش التقاعدي",
    "PROPERTY_TAX_BILL": "فاتورة ضريبة الأملاك",
    "RELEASE_OR_DISCHARGE_PAPERWORK": "أوراق الإفراج أو إخلاء السبيل",
    "RENT_RECEIPT_OR_LEASE_AGREEMENT": "إيصال إيجار أو عقد إيجار",
    "SCHOOL_ENROLLMENT_VERIFICATION_OR_TRANSCRIPT": "إثبات التسجيل الدراسي أو كشف الدرجات",
    "SIGNED_LETTER": "خطاب موقّع",
    "SIGNED_TIMESHEETS": "كشوف ساعات عمل موقّعة",
    "SNAP_TANF_VERIFICATION_LETTER": "خطاب تحقق من SNAP/TANF",
    "SOCIAL_SECURITY_CARD": "بطاقة الضمان الاجتماعي",
    "SSA_STATEMENTS": "كشوفات SSA",
    "SSDI_STATEMENTS": "كشوفات SSDI",
    "STATE_ID": "هوية الولاية",
    "STUDENT_LOANS": "قروض الطلاب",
    "TAX_RETURN": "الإقرار الضريبي (الأحدث)",
    "TRAINING_OR_APPRENTICESHIP_ENROLLMENT_CERTIFICATE": "شهادة التسجيل في تدريب أو تلمذة مهنية",
    "TREATMENT_PROGRAM_ENROLLMENT_LETTER": "خطاب التسجيل في برنامج علاج",
    "TRIBAL_ENROLLMENT_CARD_OR_LETTER": "بطاقة أو خطاب العضوية القبلية",
    "TUITION_FEES": "الرسوم الدراسية",
    "UNEMPLOYMENT_STATEMENTS": "بيانات البطالة",
    "USCIS_ID": "رقم USCIS (لغير المواطنين)",
    "UTILITY_BILL": "فاتورة خدمات",
    "VA_DISABILITY_RATING_LETTER": "خطاب تصنيف الإعاقة من VA",
    "W2_FORMS": "نماذج W-2",
    "descriptions": {
      "ALIMONY_PAID": "اتفاقية طلاق أو انفصال",
      "AUTHORIZED_EMPLOYMENT_ID": "مستند تصريح عمل من دائرة الهجرة والجنسية (USCIS)",
      "BANK_STATEMENTS": "كشوف الحسابات الجارية أو الادخار من آخر 30 يوماً",
      "BIRTH_CERTIFICATE": "شهادة ميلاد أمريكية تحتوي على اسمك وتاريخ ميلادك",
      "CHILDCARE": "كشف حساب بنكي أو إيصال أو خطاب من مقدم رعاية الأطفال",
      "CHILDS_BIRTH_CERTIFICATE": "شهادة ميلاد تحتوي على اسم طفلك وتاريخ ميلاده",
      "CHILDS_PASSPORT": "جواز سفر أمريكي يحتوي على اسم طفلك وتاريخ ميلاده",
      "COURT_ORDERED_STATEMENTS": "أمر محكمة لنفقة الأطفال، أو النفقة الزوجية، أو تعويضات العمال",
      "DOCTORS_NOTE": "خطاب من الطبيب يصف الحالة الطبية أو الإعاقة أو الحمل الذي يستند إليه هذا الإعفاء",
      "DRIVERS_LICENSE": "رخصة سارية المفعول تحتوي على اسمك وتاريخ ميلادك وعنوانك",
      "EXEMPTION_SSA_STATEMENTS": "خطاب يوضح ميزة الضمان الاجتماعي للشخص الذي ترعاه",
      "EXEMPTION_SSDI_STATEMENTS": "خطاب يوضح ميزة الإعاقة للشخص الذي ترعاه",
      "EXPENSE_OTHER": "أمر محكمة أو اتفاقية مكتوبة توضح مبلغ الدفعة",
      "FOSTER_CARE_VERIFICATION_LETTER": "خطاب من وكالة الرعاية البديلة في ولايتك يؤكد وضعك وعمرك",
      "GUARDIANSHIP_OR_CUSTODY_PAPERS": "أمر محكمة أو أوراق حضانة توضح أنك مقدم الرعاية القانوني للطفل",
      "IMIGRATION_DOCUMENTS_AND_APPROVALS": "تصريح عمل، أو تأشيرة، أو مستند آخر من USCIS يوضح وضعك",
      "IMMIGRATION_BIRTH_CERTIFICATE": "شهادة ميلاد تحتوي على اسمك وتاريخ ميلادك",
      "IMMIGRATION_PASSPORT": "جواز سفر يحتوي على اسمك وتاريخ ميلادك",
      "INSURANCE_CARD": "الوجه الأمامي والخلفي للبطاقة مع اسم الشركة ورقم الوثيقة",
      "INSURANCE_CARRIER_INFO": "مستند يحتوي على اسم شركة التأمين وعنوانها",
      "INSURANCE_POLICY_NUMBER": "مستند يوضح وثيقة التأمين الخاصة بك أو رقم عضوية الهوية",
      "IRA_CONTRIBUTIONS": "كشف من بنكك أو مزوّد IRA",
      "I_20": "نموذج ورقي من مدرستك يوضح أنه يمكنك الدراسة في الولايات المتحدة",
      "LETTER_OF_STATEMENT_FROM_EMPLOYER": "خطاب يؤكد وظيفتك وراتبك",
      "MEDICAL_EXPENSE": "كشف حساب بنكي أو فاتورة أو إيصال من طبيبك أو المستشفى أو الصيدلية",
      "MEDICARE_CARD": "بطاقة Medicare توضح أنك مسجل في Medicare الجزء A و/أو B",
      "MORTGAGE_STATEMENT": "كشف حساب الرهن العقاري خلال آخر 60 يوماً يحتوي على عنوانك",
      "MOVING_EXPENSES": "إيصالات الانتقال وخطاب من صاحب العمل",
      "PASSPORT": "جواز سفر أمريكي يحتوي على اسمك وتاريخ ميلادك",
      "PAY_STUBS": "قسائم الراتب من آخر 30 يوماً توضح إجمالي الراتب وصاحب العمل",
      "PENSION_STATEMENTS": "كشف يوضح مبلغ معاشك التقاعدي الشهري",
      "PROPERTY_TAX_BILL": "فاتورة ضريبة الأملاك التي تحتوي على عنوانك",
      "RELEASE_OR_DISCHARGE_PAPERWORK": "أوراق توضح تاريخ الإفراج عنك من السجن",
      "RENT_RECEIPT_OR_LEASE_AGREEMENT": "إيصال إيجار أو عقد يوضح عنوانك الحالي",
      "SCHOOL_ENROLLMENT_VERIFICATION_OR_TRANSCRIPT": "خطاب أو كشف درجات يوضح أنك مسجل بنصف دوام على الأقل",
      "SIGNED_LETTER": "خطاب يؤكد التدريب أو الدراسة أو التلمذة المهنية أو خدمة المجتمع",
      "SIGNED_TIMESHEETS": "كشوف ساعات عمل موقّعة من صاحب العمل أو المشرف توضح الساعات التي عملتها",
      "SNAP_TANF_VERIFICATION_LETTER": "خطاب من مكتب SNAP أو TANF يؤكد أنك تستوفي متطلبات العمل الخاصة بهم",
      "SOCIAL_SECURITY_CARD": "بطاقة تحتوي على اسمك ورقم الضمان الاجتماعي المكون من 9 أرقام",
      "SSA_STATEMENTS": "خطاب يوضح مبلغ ميزة الضمان الاجتماعي الشهري الخاص بك",
      "SSDI_STATEMENTS": "خطاب يوضح ميزة العجز الشهرية الخاصة بك",
      "STATE_ID": "بطاقة هوية الولاية الحالية تحتوي على اسمك وتاريخ ميلادك وعنوانك",
      "STUDENT_LOANS": "كشف من بنكك أو جهة خدمة القرض",
      "TAX_RETURN": "الإقرار الضريبي الكامل للسنة الماضية",
      "TRAINING_OR_APPRENTICESHIP_ENROLLMENT_CERTIFICATE": "شهادة أو خطاب يوضح أنك مسجل في برنامج تدريب أو تلمذة مهنية",
      "TREATMENT_PROGRAM_ENROLLMENT_LETTER": "خطاب يؤكد أنك مسجل في برنامج علاج من المخدرات أو الكحول",
      "TRIBAL_ENROLLMENT_CARD_OR_LETTER": "بطاقة هوية قبلية أو خطاب يؤكد عضويتك",
      "TUITION_FEES": "إيصال أو فاتورة من مدرستك",
      "UNEMPLOYMENT_STATEMENTS": "خطاب يوضح ميزات البطالة الأسبوعية أو الشهرية الخاصة بك",
      "USCIS_ID": "بطاقة خضراء، أو تصريح عمل، أو شهادة جنسية",
      "UTILITY_BILL": "فاتورة من آخر 60 يوماً للكهرباء أو الغاز أو الماء أو الهاتف مع عنوانك",
      "VA_DISABILITY_RATING_LETTER": "خطاب من VA يوضح تصنيف إعاقتك بنسبة 100%",
      "W2_FORMS": "أحدث نموذج W-2 يوضح صاحب العمل والأجور"
    }
  },
  "documents": {
    "choosePhoto": "اختيار صورة",
    "takePhoto": "التقاط صورة"
  },
  "done": "تم",
  "edit": "تعديل",
  "email": "البريد الإلكتروني",
  "error": "خطأ",
  "errorFallback": {
    "description": "واجهنا مشكلة في تحميل هذه الصفحة.",
    "resetCta": "حاول مرة أخرى",
    "title": "حدث خطأ ما."
  },
  "errors": {
    "appleSsoNotSupported": "تسجيل الدخول باستخدام Apple غير متاح. يرجى تجربة خيار آخر.",
    "emptyHomeAddress": "يرجى إدخال واختيار عنوان سكنك، أو اختر \"لا يوجد عنوان سكن ثابت\".",
    "emptyMailingAddress": "يرجى إدخال واختيار عنوان المراسلة، أو اختر \"لا يوجد عنوان مراسلة\".",
    "googleSsoNotSupported": "تسجيل الدخول باستخدام Google غير متاح. يرجى تجربة خيار آخر.",
    "invalidEmail": "يرجى إدخال بريد إلكتروني صحيح (مثلاً: name@example.com).",
    "selectValidOption": "يرجى اختيار خيار صحيح.",
    "unableToCreateApplications": "لم نتمكن من إرسال طلباتك. يرجى التأكد من الإنترنت والمحاولة مرة أخرى.",
    "unauthenticated": "يرجى تسجيل الدخول للمتابعة.",
    "unauthorized": "ليس لديك صلاحية للدخول. إذا كان هذا خطأ، راسلنا على support@pointcare.com.",
    "unknown": "حدث خطأ ما. يرجى المحاولة مرة أخرى."
  },
  "exit": "خروج",
  "female": "أنثى",
  "filesWithCount_one": "ملف واحد",
  "filesWithCount_other": "{{count}} ملفات",
  "healthInsuranceOrCoverageStatus": {
    "EMPLOYER": "تأمين صحي من خلال العمل (مقدم من صاحب العمل)",
    "MEDICAID": "Medicaid",
    "MEDICARE": "Medicare",
    "OTHER": "آخر",
    "PRIVATE": "تأمين خاص أو سوق قانون الرعاية ميسورة التكلفة (ACA)",
    "TRICARE": "TRICARE (تغطية صحية عسكرية)",
    "VA": "برنامج رعاية VA الصحية"
  },
  "home": "الرئيسية",
  "householdMember": "فرد في الأسرة",
  "listConnector": " و ",
  "listSeparator": "، ",
  "loading": "جاري التحميل...",
  "login": {
    "checkYourEmail": "تحقق من بريدك الإلكتروني {{email}} للحصول على رابط تسجيل الدخول.",
    "placeholder": "name@example.com",
    "sendEmail": "إرسال البريد"
  },
  "longDateFormat": "D MMMM YYYY",
  "male": "ذكر",
  "maritalStatus": {
    "COMMON_LAW": "زواج العرفي",
    "DIVORCED": "مطلق",
    "MARRIED": "متزوج",
    "NEVER_MARRIED": "أعزب/لم يسبق له الزواج",
    "REGISTERED_DOMESTIC_PARTNER": "شريك محلي مسجل",
    "SEPARATED": "منفصل",
    "WIDOWED": "أرمل"
  },
  "marketplace": "سوق قانون الرعاية ميسورة التكلفة (ACA)",
  "medicaid": "Medicaid",
  "medicare": "Medicare",
  "medicarePlanType": {
    "ADVANTAGE": "Medicare Advantage (الجزء C)",
    "NOT_SURE": "لست متأكداً",
    "ORIGINAL": "الجزءان A وB (الأصلي)"
  },
  "member_one": "عضو واحد",
  "member_other": "{{count}} أعضاء",
  "month": "شهر",
  "next": "التالي",
  "no": "لا",
  "noResults": "لم يتم العثور على نتائج",
  "noneOfTheAbove": "لا شيء مما سبق",
  "ok": "حسناً",
  "open": "فتح",
  "or": "أو",
  "pagination": {
    "goToFirstPage": "الانتقال للصفحة الأولى",
    "goToLastPage": "الانتقال للصفحة الأخيرة",
    "goToNextPage": "الصفحة التالية",
    "goToPreviousPage": "الصفحة السابقة",
    "morePages": "صفحات إضافية",
    "pagination": "ترقيم الصفحات",
    "rowsPerPage": "عدد الصفوف في الصفحة",
    "rowsResults": "من {{from}} إلى {{to}} من أصل {{total}} نتيجة",
    "showingPrefix": "عرض "
  },
  "payFrequency": {
    "ANNUALLY": "سنوياً",
    "BI_WEEKLY": "كل أسبوعين",
    "MONTHLY": "شهرياً",
    "WEEKLY": "أسبوعياً"
  },
  "pdfViewer": {
    "loading": "جاري تحميل المستند..."
  },
  "program_one": "برنامج واحد",
  "program_other": "{{count}} برامج",
  "progressIndicator": "التقدم: تم إكمال {{progress}} من {{total}}",
  "relationships": {
    "CHILD": "طفل",
    "FOSTER_CHILD": "طفل تحت الرعاية",
    "GRANDCHILD": "حفيد",
    "GRANDPARENT": "جد/جدة",
    "OTHER": "آخر",
    "PARENT": "والد/والدة",
    "PARTNER": "شريك",
    "SIBLING": "أخ/أخت",
    "SPOUSE": "زوج/زوجة",
    "STEPCHILD": "ابن الزوج/الزوجة"
  },
  "required": "هذا الحقل مطلوب.",
  "returnToDashboard": "العودة إلى لوحة التحكم",
  "save": "حفظ",
  "saveChanges": "حفظ التغييرات",
  "share": "مشاركة",
  "sidebar": {
    "title": "الشريط الجانبي",
    "toggle": "تبديل الشريط الجانبي"
  },
  "signOut": "تسجيل الخروج",
  "skip": "تخطي",
  "stepIndicator": "الخطوة {{currentStep}} من {{totalSteps}}",
  "submit": "إرسال",
  "tabs": {
    "home": "الرئيسية"
  },
  "taxFilingStatus": {
    "HEAD": "رئيس الأسرة",
    "JOINTLY": "متزوجان يقدمان معاً",
    "NON_FILER": "لا يقدم إقراراً",
    "SEPARATELY": "متزوجان يقدمان منفصلين",
    "SINGLE": "أعزب",
    "WIDOWER": "أرمل مؤهل مع طفل تابع"
  },
  "theme": "المظهر",
  "time": {
    "am": "صباحاً",
    "pm": "مساءً"
  },
  "undo": "تراجع",
  "unknown": "غير معروف",
  "uploadButton": {
    "title": "تحميل ملف أو التقاط صورة"
  },
  "validation": {
    "atLeastOneOption": "يرجى اختيار خيار واحد على الأقل.",
    "genericError": "لم ينجح الأمر. يرجى المحاولة مرة أخرى.",
    "invalidCode": "هذا الرمز غير مطابق. يرجى التأكد منه أو طلب رمز جديد.",
    "invalidEmail": "يرجى إدخال بريد إلكتروني صحيح (مثلاً: name@example.com).",
    "invalidNumber": "يرجى إدخال رقم صحيح.",
    "invalidPassword": "كلمة المرور غير صحيحة. يرجى المحاولة مرة أخرى.",
    "invalidPhone": "يرجى إدخال رقم هاتف مكون من 10 أرقام.",
    "invalidSsn": "يجب أن يحتوي رقم الضمان الاجتماعي على أرقام فقط (بدون فواصل أو مسافات).",
    "invalidSsnFormat": "رقم الضمان الاجتماعي هذا غير صالح. يرجى التأكد منه والمحاولة مرة أخرى.",
    "invalidSsnLength": "يرجى إدخال رقم الضمان الاجتماعي المكون من 9 أرقام.",
    "numberMustBeNonNegative": "يرجى إدخال رقم يساوي الصفر أو أكثر.",
    "passwordMismatch": "كلمتا المرور غير متطابقتين.",
    "requiredField": "يرجى ملء هذا الحقل.",
    "requiredFields": "يرجى ملء جميع الحقول المطلوبة.",
    "requiredNonNegative": "يرجى إدخال رقم يساوي الصفر أو أكثر.",
    "requiredPassword": "يرجى إدخال كلمة المرور الخاصة بك.",
    "unknown": "حدث خطأ ما. يرجى المحاولة مرة أخرى."
  },
  "verifySignInWithEmailLinkScreen": {
    "confirmEmailPrompt": "أدخل بريدك الإلكتروني لإكمال تسجيل الدخول",
    "verify": "تحقق",
    "verifyError": "لم نتمكن من التأكد من رابط الدخول الخاص بك. ربما انتهت صلاحيته. يرجى طلب رابط جديد."
  },
  "whoApplies": "على من ينطبق هذا؟",
  "whoIsApplying": "من الذي يقدم الطلب؟",
  "year": "سنة",
  "yes": "نعم",
  "zoom": "تكبير/تصغير",
  "zoomIn": "تكبير",
  "zoomOut": "تصغير",
  "zoomReset": "إعادة ضبط التكبير"
}
